import { render, staticRenderFns } from "./WorkBookProsAndCons.vue?vue&type=template&id=7e0cf9ec&scoped=true&"
import script from "./WorkBookProsAndCons.vue?vue&type=script&lang=js&"
export * from "./WorkBookProsAndCons.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookProsAndCons.vue?vue&type=style&index=0&id=7e0cf9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0cf9ec",
  null
  
)

export default component.exports